/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S6_P1Inputs */

const tr_onbilgi_s6_p1 = /** @type {(inputs: Onbilgi_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik, seçilen süre için (aylık plan 30 gün, yıllık plan 365 gün) peşin ödenir ve süre sonunda kendiliğinden sona erer. Otomatik yenileme yapılmaz ve kayıtlı karttan otomatik tahsilat gerçekleştirilmez. Müşteri aşağıdaki şekilde bilgilendirilir:`)
};

const en_onbilgi_s6_p1 = /** @type {(inputs: Onbilgi_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subscription is paid in advance for the chosen term (monthly plan 30 days, yearly plan 365 days) and ends by itself at the end of the term. There is no automatic renewal and no automatic charge to a stored card. The Customer is informed as follows:`)
};

const de_onbilgi_s6_p1 = /** @type {(inputs: Onbilgi_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Abonnement wird für die gewählte Laufzeit (Monatstarif 30 Tage, Jahrestarif 365 Tage) im Voraus bezahlt und endet mit Ablauf der Laufzeit von selbst. Es gibt keine automatische Verlängerung und keinen automatischen Einzug von einer gespeicherten Karte. Der Kunde wird wie folgt informiert:`)
};

const ru_onbilgi_s6_p1 = /** @type {(inputs: Onbilgi_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка оплачивается заранее за выбранный срок (месячный тариф 30 дней, годовой тариф 365 дней) и по окончании срока прекращается сама. Автоматического продления и автоматического списания с сохранённой карты не производится. Клиент информируется следующим образом:`)
};

/**
* | output |
* | --- |
* | "The subscription is paid in advance for the chosen term (monthly plan 30 days, yearly plan 365 days) and ends by itself at the end of the term. There is no a..." |
*
* @param {Onbilgi_S6_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s6_p1 = /** @type {((inputs?: Onbilgi_S6_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S6_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s6_p1(inputs)
	if (locale === "de") return de_onbilgi_s6_p1(inputs)
	if (locale === "ru") return ru_onbilgi_s6_p1(inputs)
	return tr_onbilgi_s6_p1(inputs)
});